import { HashRouter, Routes, Route } from "react-router-dom";
import ZumAltenRathausApp from "./app/ZumAltenRathausApp";
import Impressum from "./app/Impressum";
import Datenschutz from "./app/Datenschutz";

export default function App() {
    return (
        <HashRouter>
            <Routes>
                <Route path="/" element={<ZumAltenRathausApp />} />
                <Route path="/impressum" element={<Impressum />} />
                <Route path="/datenschutz" element={<Datenschutz />} />
            </Routes>
        </HashRouter>
    );
}